import { Box, Typography } from '@mui/material';

type LabeledListProps = {
    label: string;
    adornment?: React.ReactNode;
    children: React.ReactNode;
};

export default function LabeledList({
    label,
    adornment,
    children,
}: LabeledListProps) {
    return (
        <Box
            p={1}
            sx={(theme) => ({
                borderRadius: `${theme.shape.borderRadius}px`,
                border: `1px solid ${theme.palette.divider}`,
            })}
        >
            <Box position="relative" height="100%" width="100%">
                <Box
                    sx={(theme) => ({
                        position: 'absolute',
                        top: theme.spacing(-2.5),
                        left: theme.spacing(0),
                        backgroundColor: 'background.default',
                        padding: `0 ${theme.spacing(0.5)}`,
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: theme.spacing(0.5),
                    })}
                >
                    <Typography
                        variant="caption"
                        component="label"
                        color="text.secondary"
                    >
                        {label}
                    </Typography>
                    {adornment}
                </Box>

                <Box
                    sx={{
                        position: 'absolute',
                        overflowY: 'auto',
                        height: '100%',
                        width: '100%',
                    }}
                >
                    {children}
                </Box>
            </Box>
        </Box>
    );
}
